// 与 grid.ts 的 MAX_ROWS 一致。不从那里 import：node --test 解析不了无后缀的本地模块。
export const CHAMBER_MAX_ROWS = 1000

type Matrix = string[][]

/**
 * 上膛：把这一批域名追加到草稿第 1 页的 A 列。
 * 页上已经有字时，先空一行再写；空页从第一行开始。
 * 写不进去就原样退回，不改一半。
 */
export function appendChamberBatch(
  cells: Matrix,
  domains: string[],
): { cells: Matrix; error?: string } {
  const names = domains.map((d) => d.trim()).filter((d) => d !== '')
  if (names.length === 0) return { cells, error: '没有要上膛的域名' }

  let last = -1
  cells.forEach((row, r) => {
    if (row.some((v) => v.trim() !== '')) last = Math.max(last, r)
  })
  const start = last < 0 ? 0 : last + 2
  if (start + names.length > CHAMBER_MAX_ROWS) {
    const room = Math.max(0, CHAMBER_MAX_ROWS - start)
    return { cells, error: `草稿第 1 页只剩 ${room} 行，这批有 ${names.length} 个，写不进去` }
  }

  const width = Math.max(1, ...cells.map((row) => row.length))
  const next: Matrix = cells.map((row) => row.slice())
  while (next.length < start + names.length) next.push(Array.from({ length: width }, () => ''))
  for (let i = 0; i < names.length; i++) {
    const row = (next[start + i] ?? []).slice()
    while (row.length < width) row.push('')
    row[0] = names[i]
    next[start + i] = row
  }
  return { cells: next }
}

export function chamberResultNote(batchCode: string, parked: boolean, parkError?: string): string {
  if (parked) {
    return `批次 ${batchCode} · 已上膛到草稿第 1 页，这批写在一起。下一次上膛会先空一行再续。要整批撤回就去批次页。`
  }
  return `批次 ${batchCode} · 已经出库，但没有写进草稿（${parkError || '未知原因'}）。请用「复制」贴到草稿第 1 页。要整批撤回就去批次页。`
}
